import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  Fragment,
} from "react";
import { useHistory, useLocation } from "react-router-dom";

import moment from "moment";
import Grid from "@material-ui/core/Grid";

import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import ManifestModal from "../Users/ManifestModal";
import PDFViewerModal from "../../components/PDFViewer";
import ConfirmationModal from "../../components/ConfirmationModal";

import "./index.css";

const default_avatar = require("../../assets/media/user.png");

const MemberReferrals = () => {
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [currentMonthCount, setCurrentMonthCount] = useState(0);
  const [currentWeekCount, setCurrentWeekCount] = useState(0);
  const [currentDayCount, setCurrentDayCount] = useState(0);
  const [convertedMemberCount, setConvertedMemberCount] = useState(0);
  const [referralData, setReferralData] = useState([]);
  const [userToManifest, setUserToManifest] = useState({});
  const [selectedTicket, setSelectedTicket] = useState({});
  const [selectedPDF, setSelectedPDF] = useState("");
  const [deleteUser, setDeleteUser] = useState({});

  const manifestModalRef = useRef();
  const openModalBtn = useRef();
  const history = useHistory();
  const location = useLocation();

  const loadUser = (brand) => {
    const { role } = location.state;
    Firebase.getBrandDataByID(brand, (brand_data) => {
      if (brand_data) {
        setBrandData(brand_data);
        Firebase.getReferralsByBrand(brand_data.name, async (res) => {
          const promises = res.map(async (ref) => {
            return new Promise((resolve, reject) => {
              Firebase.getUserDatafromUID(
                brand_data.name,
                ref.referredUID
              ).then((referred_user) => {
                if (referred_user) {
                  Firebase.getUserDatafromUID(
                    brand_data.name,
                    ref.memberID
                  ).then(async (member) => {
                    if (member) {
                      resolve({
                        ...ref,
                        user_access: referred_user.user_access,
                        referred_user: { ...referred_user },
                        member: { ...member },
                      });
                    } else {
                      resolve({
                        ...ref,
                        user_access: referred_user.user_access,
                        referred_user: { ...referred_user },
                        member: {},
                      });
                    }
                  });
                } else {
                  resolve(null);
                }
              });
            });
          });
          let referrals = (await Promise.all(promises)).filter((ref) => ref);
          console.log("referral data", referrals);
          const uid = localStorage.getItem("uid");
          Firebase.getAgencyData(uid, (agencyData) => {
            const { type } = agencyData;
            if (["Sales manager", "Sales rep"].includes(type)) {
              referrals = referrals.filter(
                (ref) => ref.member.accountant === uid
              );
              console.log("filtered:", referrals);
            }
            setReferralData(referrals);
            setCurrentMonthCount(
              referrals.filter((ref) =>
                moment(ref.time).isSame(new Date(), "month")
              ).length
            );
            setCurrentWeekCount(
              referrals.filter((ref) =>
                moment(ref.time).isSame(new Date(), "week")
              ).length
            );
            setCurrentDayCount(
              referrals.filter((ref) =>
                moment(ref.time).isSame(new Date(), "day")
              ).length
            );
            setConvertedMemberCount(
              referrals.filter(
                (ref) =>
                  ref.user_access !== "Referred prospect" &&
                  ref.user_access !== "Pending member"
              ).length
            );
            setLoading(false);
          });
        });
      }
    });
  };

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setRole(role);
      setBrand(brand);
      setLoading(true);
      setUserName(username);

      loadUser(brand);
    }
  }, [location]);

  const handleChangeProfile = async ({ brandChanges, ecoChanges }) => {
    const { eco_id } = userToManifest;
    setLoading(true);

    if (ecoChanges) {
      if (eco_id) {
        await Firebase.updateEcoUser(eco_id, ecoChanges); //if eco user then update eco data
      } else {
        await Firebase.updateUserData(
          brandData.name,
          userToManifest.id,
          ecoChanges
        ); // update user data
      }
    }
    if (brandChanges) {
      await Firebase.updateUserData(
        brandData.name,
        userToManifest.id,
        brandChanges
      );
    }

    loadUser(brand);
    // setIsRefreshing(Math.random());
  };

  const handleClickTicket = (ticket) => {
    setSelectedTicket(ticket);
  };

  const handleClickAttachment = (content) => {
    const { media_type, media_url } = content;
    if (media_type === "pdf_file") setSelectedPDF(media_url);
  };

  const onRemoveUser = useCallback(async () => {
    setLoading(true);
    await Firebase.removeCommunityMember(deleteUser.id, brandData.name);
    Firebase.getReferralsByBrand(brandData.name, (referrals) => {
      const deleteID = referrals.find(
        (ref) => ref.referredID === deleteUser.id
      );
      if (deleteID) {
        Firebase.deleteReferral(brandData.name, deleteID);
      }
    });
    setLoading(false);
    // setAllMembers(allMembers.filter((member) => member.id !== deleteUser.id));
    manifestModalRef.current.close();
    //this.loadUser();
  });

  const showManifestModal = (uid, eco_id) => {
    setUserToManifest({ id: uid, eco_id: eco_id });
    openModalBtn.current.click();
  };

  return (
    <div id="page-container">
      {loading && (
        <div className="loading_gif">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      )}
      <Header
        username={username}
        role={role}
        logo={brandData.logo}
        brand={brand}
        brandName={brandData.name}
        is_property_brand={brandData.is_property_brand}
      />
      <div className="referrals-content">
        <div className="content-header">
          <Grid container spacing={3}>
            <Grid item xs={2}>
              <p>
                Total referrals:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {referralData.length}
                </span>
              </p>
            </Grid>
            <Grid item xs={2}>
              <p>
                Referrals this month:{" "}
                <span style={{ fontWeight: "bold" }}>{currentMonthCount}</span>
              </p>
            </Grid>
            <Grid item xs={2}>
              <p>
                Referrals this week:{" "}
                <span style={{ fontWeight: "bold" }}>{currentWeekCount}</span>
              </p>
            </Grid>
            <Grid item xs={2}>
              <p>
                Referrals today:{" "}
                <span style={{ fontWeight: "bold" }}>{currentDayCount}</span>
              </p>
            </Grid>
            <Grid item xs={4}>
              <p>
                Referrals converted to members:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {convertedMemberCount}
                </span>
              </p>
            </Grid>
          </Grid>
        </div>
        <div className="table-header">
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={1}>
              <p>Date</p>
            </Grid>
            <Grid item xs={3}>
              <p>Referred prospect name</p>
            </Grid>
            <Grid item xs={2}>
              <p>Routing</p>
            </Grid>
            <Grid item xs={2}>
              <p>Member name</p>
            </Grid>
            <Grid item xs={2}>
              <p>Referral code</p>
            </Grid>
            <Grid item xs={2}>
              <p>Converted to member</p>
            </Grid>
          </Grid>
        </div>
        {referralData.map((referral) => {
          return (
            <div className="table-content">
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={1}>
                  <p>
                    {brandData.territory === "USA"
                      ? moment(referral.time).format("MM/DD/YYYY")
                      : moment(referral.time).format("DD.MM.YYYY")}
                  </p>
                </Grid>
                <Grid
                  item
                  xs={3}
                  className="personal-info"
                  onClick={() =>
                    showManifestModal(
                      referral.referredUID,
                      referral.referred_user.eco_id
                    )
                  }
                >
                  <img
                    alt=""
                    src={referral.referred_user.avatar_url || default_avatar}
                  />
                  <p>{referral.referred_user.firstname}</p>
                </Grid>
                <Grid item xs={2}>
                  <p>{referral.routing}</p>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className="personal-info"
                  onClick={() =>
                    showManifestModal(referral.memberID, referral.member.eco_id)
                  }
                >
                  <img
                    alt=""
                    src={referral.member.avatar_url || default_avatar}
                  />
                  <p>{referral.memberName}</p>
                </Grid>
                <Grid item xs={2}>
                  <p>{referral.referralCode}</p>
                </Grid>
                <Grid item xs={2}>
                  <p>
                    {referral.user_access === "Referred prospect" ||
                    referral.user_access === "Pending member"
                      ? "Pending"
                      : "Converted"}
                  </p>
                </Grid>
              </Grid>
            </div>
          );
        })}
      </div>
      <button
        style={{ display: "none" }}
        ref={openModalBtn}
        data-toggle="modal"
        data-target="#manifest_modal"
      />
      {brandData.name && (
        <Fragment>
          <ManifestModal
            user={userToManifest}
            brandData={brandData}
            categories={brandData.userCategories || []}
            isChatCRMNotVisible={
              brandData &&
              brandData.permissions &&
              !brandData.permissions.concierge &&
              !brandData.permissions.tickets &&
              !brandData.permissions.newchat
            }
            onChangeProfile={handleChangeProfile}
            onClickTicket={handleClickTicket}
            onClickAttachment={handleClickAttachment}
            removeUser={setDeleteUser}
            ref={manifestModalRef}
          />
          <PDFViewerModal pdfUrl={selectedPDF} />
          <ConfirmationModal
            title="Are you sure you want to remove this user?"
            id="remove_user"
            onClick={onRemoveUser}
            hex={brandData.hex}
            white={brandData.white}
          />
        </Fragment>
      )}
    </div>
  );
};

export default MemberReferrals;



// WEBPACK FOOTER //
// ./src/screens/MemberReferrals/index.js